import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import { event, LOGINURL, closeDialog, EVENTNAMES } from '../core/';
import styles from './index.css';

const createMarkup = function createMarkup(src) {
    return {
        __html: `<iframe width="520" height="410" scrolling="no" frameborder="no" border="0" style="border:0px; margin:0px;padding:0px;" src="${src}"></iframe>`,
    };
};

export default class LoginDialog extends React.PureComponent {
    static propTypes = { id: PropTypes.string.isRequired };
    static defaultProps = {};
    state = {
        isOpen: false,
        src: LOGINURL,
    };

    closeHandle = () => {
        closeDialog();
    };

    componentDidMount() {
        this.unbindDialogOpen = event.on(EVENTNAMES.dialogOpen, (src = LOGINURL, id) => {
            if (id === this.props.id) {
                this.setState({
                    isOpen: true,
                    src,
                });
            }
        });
        this.unbindDialogClose = event.on(EVENTNAMES.dialogClose, () => {
            this.setState({
                isOpen: false,
                src: LOGINURL,
            });
        });
        this.unBindUrlChang = event.on(EVENTNAMES.urlChange, url => {
            this.setState({
                src: url,
            });
        });
    }
    componentWillUnmount() {
        this.unbindDialogOpen();
        this.unbindDialogClose();
        this.unBindUrlChang();
    }
    render() {
        const { isOpen, src } = this.state;

        return isOpen
            ? ReactDom.createPortal(
                  [
                      <div className={styles.mask} key="mask" />,
                      <div className={styles.box} key="box">
                          <div className={styles.close} onClick={this.closeHandle} id="auth_close_btn" />
                          <div dangerouslySetInnerHTML={createMarkup(src)} />
                      </div>,
                  ],
                  document.body,
              )
            : null;
    }
}
